var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cells-container"}},_vm._l((_vm.cells),function(cell){return _c('Cell',{key:cell.id,attrs:{"gameOver":_vm.gameOver,"turn":_vm.turn,"cell":cell}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }